import React, { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStore } from '../../contexts/StoreContext';
import AuthGate from '../../components/AuthGate/AuthGate';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import './JoinStore.scss';

/**
 * JoinStore Page
 * Allows user to join a store using invitation token
 */

const JoinStore: React.FC = () => {
  const navigate = useNavigate();
  const { joinStore, isLoading, error, clearError } = useStore();

  const [invitationToken, setInvitationToken] = useState('');
  const [fieldError, setFieldError] = useState('');

  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInvitationToken(value);

    if (fieldError) {
      setFieldError('');
    }

    if (error) {
      clearError();
    }
  };

  // Validate form
  const validateForm = (): boolean => {
    if (!invitationToken.trim()) {
      setFieldError('Le code d’invitation est obligatoire');
      return false;
    }

    return true;
  };

  // Handle form submit
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      await joinStore(invitationToken.trim());
      // Navigate to orders page of joined store
      navigate('/orders');
    } catch (err) {
      console.error('Join store error:', err);
    }
  };

  const handleCancel = () => {
    navigate('/stores');
  };

  return (
    <AuthGate homeTo="/stores">
      <Link className="auth-back" to="/stores">Stores</Link>
      <p className="auth-kicker">Invitation</p>
      <h1 className="auth-h">Rejoindre un store</h1>
      <p className="auth-sub">Collez le code reçu.</p>

      {error && (
        <div className="auth-alert auth-alert--error">{error}</div>
      )}

      <form className="auth-form" onSubmit={handleSubmit}>
        <Input
          label="Code d’invitation"
          type="text"
          name="invitationToken"
          value={invitationToken}
          onChange={handleChange}
          error={fieldError}
          placeholder="Collez le code ici"
          required
          fullWidth
          autoFocus
        />

        <p className="join-store-hint">Demandez-le à un owner ou un admin.</p>

        <div className="auth-actions">
          <Button
            type="button"
            variant="outline"
            size="large"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Annuler
          </Button>

          <Button
            type="submit"
            variant="primary"
            size="large"
            loading={isLoading}
          >
            Rejoindre
          </Button>
        </div>
      </form>
    </AuthGate>
  );
};

export default JoinStore;

